import React, { useContext } from 'react';
import styled from 'styled-components';
import Marquee from 'react-fast-marquee';
import { Link } from 'react-router-dom';
import { UserContext, useAnnouncement } from '../hooks';

function Header() {
  const { isMember } = useContext(UserContext);
  const { announcement } = useAnnouncement();

  return (
    <StyledDiv>
      <Marquee key={announcement} speed={40} pauseOnHover gradient={false}>
        <span className="announcement-text">
          {'     | ' + announcement + ' |     '}
          {!isMember && (
            <>
              &nbsp; | &nbsp;
              <StyledLink to="/membership">
                🔥 ¡Hazte Socio Ahora! 🔥
              </StyledLink>
            </>
          )}
        </span>
      </Marquee>
    </StyledDiv>
  );
}

const StyledDiv = styled.div`
  background-color: black;
  color: white;
  height: 40px;
  display: flex;
  align-items: center;
  overflow: hidden;

  .announcement-text {
    font-size: 1rem;
    font-weight: 500;
  }
`;

const StyledLink = styled(Link)`
  color: #f5c518;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: #ffd700;
    text-decoration: underline;
  }
`;

export default Header;
